module.exports = __webpack_public_path__ + "img/1557398400.a52e1d23.jpg";